import get from 'lodash/get';

export const UPDATE_ACTIVE_CANVAS_DRAWER = 'UPDATE_ACTIVE_CANVAS_DRAWER';
export const SET_COMPLETED_DRAWER = 'SET_COMPLETED_DRAWER';
export const OPEN_SAVE_FOR_LATER = 'OPEN_SAVE_FOR_LATER';
export const CLOSE_SAVE_FOR_LATER = 'CLOSE_SAVE_FOR_LATER';

let timer;

export const updateActiveCanvasDrawer = drawer => ({
  type: UPDATE_ACTIVE_CANVAS_DRAWER,
  drawer,
});

export const setCompletedDrawer = drawer => ({
  type: SET_COMPLETED_DRAWER,
  drawer,
});

export const openSaveForLater = () => ({
  type: OPEN_SAVE_FOR_LATER,
});

export const closeSaveForLater = () => ({
  type: CLOSE_SAVE_FOR_LATER,
});

export const setCompletedDrawerWithTimer = dispatch => (drawer, timeout = 3000) => {
  if (timer) {
    clearTimeout(timer);
  }
  dispatch(setCompletedDrawer(drawer));
  timer = setTimeout(() => {
    dispatch(setCompletedDrawer(null));
  }, timeout);

};

export const getActiveCanvasDrawer = state =>
  state.components.canvasDrawers.activeDrawer;

export const getCompletedDrawer = state =>
  state.components.canvasDrawers.completedDrawer;

export const isSaveForLaterOpen = state => get(state, 'components.canvasDrawers.saveForLaterOpen', false);

export default (state = {}, action) => {
  switch (action.type) {
    case UPDATE_ACTIVE_CANVAS_DRAWER: {
      return {
        ...state,
        activeDrawer: state.activeDrawer === action.drawer ? null : action.drawer,
      };
    }
    case SET_COMPLETED_DRAWER: {
      return {
        ...state,
        completedDrawer: action.drawer,
      };
    }
    case OPEN_SAVE_FOR_LATER: {
      return {
        ...state,
        saveForLaterOpen: true,
      };
    }
    case CLOSE_SAVE_FOR_LATER: {
      return {
        ...state,
        saveForLaterOpen: false,
      };
    }
    default: {
      return state;
    }
  }
};
